import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { AutotextService } from "../autotext.service";
import { ExamsService } from "../exams.service";
import { PatientsService } from "../patients.service";
import { AngularEditorConfig, UploadResponse } from "@kolkov/angular-editor";
import { Observable, Subscription } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { LoginService } from "../login.service";

export interface Template {
  TemplateID: string;
  UID: string;
  Title: string;
  TemplateContent: string;
}

@Component({
    selector: "app-consultation",
    templateUrl: "./consultation.component.html",
    styleUrls: ["./consultation.component.scss"],
    standalone: false
})
export class ConsultationComponent implements OnInit {
  @ViewChild("Title") Title: ElementRef;
  @ViewChild("titleValue") titleValue: ElementRef;
  showEdit = false;
  showPopup = false;
  inputValue = "";
  templates: Template[] = [];
  selectedTemplate = false;
  consultation: UntypedFormGroup;
  input1: string;
  input2: string;
  editorConfig: AngularEditorConfig = {
    editable: true,
    height: "50vh",
    toolbarHiddenButtons: [
      ["subscript", "superscript", "strikeThrough"],
      [
        "backgroundColor",
        "customClasses",
        "link",
        "unlink",
        "insertImage",
        "insertVideo",
        "removeFormat",
        "toggleEditorMode",
      ],
    ],
  };
  constructor(
    private patService: PatientsService,
    private http: HttpClient,
    public atS: AutotextService,
    public es: ExamsService,
    private fb: UntypedFormBuilder,
    public ls: LoginService

  ) {}

  ngOnInit() {
    this.consultation = this.fb.group({
      FormContent: [""],
      selectedTemplate: [""],
      Title: new UntypedFormControl("", Validators.minLength(2)),
    });
    this.es.fillForm(this.consultation, "Forms", false, true);
    if(!this.ls.ishospital){
    this.http.get("/api/templates").subscribe((data) => {
      this.templates = data as Template[];
    });}
  }
  createTemplate(titleValue: string) {
    const TemplateContent = this.consultation.get("FormContent").value;
    const Title = titleValue;

    if (!TemplateContent || !Title) {
      return;
    }

    const body = { TemplateContent, Title };
    this.http.post("/api/templates", body).subscribe((data) => {
      this.templates = data as Template[];
      this.titleValue.nativeElement.value = "";
    });
  }

  checkTemplate(titleValue: string) {
    if (!titleValue || !this.consultation.get("FormContent").value) {
      return true;
    }
    return false;
  }

  deleteTemplate(templateId: string) {
    if (!templateId) return;
    this.http.delete(`/api/templates/${templateId}`).subscribe((data) => {
      this.templates = data as Template[];
    });
  }
  editTemplate(templateId: string) {
    if (!templateId) return;
    const TemplateContent = this.consultation.get("FormContent").value;
    const [selectedTemplate] = this.templates.filter(
      (template) => template.TemplateID == templateId
    );
    const currentTitle = selectedTemplate.Title;
    const newTitle = this.titleValue.nativeElement.value;
    const Title = newTitle || currentTitle;
    const body = { Title, TemplateContent };
    this.http.put(`/api/templates/${templateId}`, body).subscribe((data) => {
      this.templates = data as Template[];
      this.titleValue.nativeElement.value = "";
      this.showPopup = false;
    });
  }
  setTemplate(templateId: string) {
    if (!templateId) return;
    this.selectedTemplate = true;
    let [selectedTemplate] = this.templates.filter(
      (template) => template.TemplateID == templateId
    );
    const formContent=this.consultation
    .get("FormContent").value;
    this.consultation
      .get("FormContent")
      .setValue(formContent? formContent+ '<br>' +selectedTemplate.TemplateContent:selectedTemplate.TemplateContent);
      let title=selectedTemplate.Title
      this.consultation.get('selectedTemplate').setValue(title)

      if(!this.consultation.get('Title').value){
        this.consultation.get('Title').setValue(title);
        this.es.changeTitle(this.consultation.get('Title').value,true)
       }

      else if(this.templates.filter(
        (template) => template.Title === this.consultation.get('Title').value
      ).length){
        this.consultation.get('Title').setValue(title)
        this.es.changeTitle(this.consultation.get('Title').value,true)
      }

  }
  checkTextChanged(templateId: string, title?: string) {
    if (templateId) {
      const [currentTemplate] = this.templates.filter(
        (template) => templateId == template.TemplateID
      );
      if (
        currentTemplate.TemplateContent !==
        this.consultation.get("FormContent").value
      ) {
        return (this.showEdit = true);
      }
      if (currentTemplate.Title != title && title) {
        return (this.showEdit = true);
      }
    }
    this.showEdit = false;
  }

  changeTitle(){
    if(!this.consultation.get('Title').value){
      const templateTitle=this.consultation.get('selectedTemplate').value
      this.consultation.get('Title').setValue(templateTitle)
    }
    
      this.es.changeTitle(this.consultation.get('Title').value,true)
    
  }
}
